import {lazy} from 'react';

export const ProductPricingBoxContainerLazy = lazy(() => import(/* webpackChunkName: "productPricingBoxContainer" */ '.'));
